import React from 'react';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../useApiMutation';
import useMessage from '../../useMessage';

const useCancelAcastPlus = () => {
  const { message } = useMessage();
  const mutation = useApiMutation({
    getRequestUrl: ({ showId }) => `/plus/shows/${showId}`,
    method: 'DELETE',
    onSuccess: () => {
      message.success({
        content: <FormattedMessage defaultMessage="Subscriptions cancellation started." />,
      });
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while cancelling acast plus." />
        ),
      });
    },
  });

  return {
    cancelAcastPlus: mutation.mutate,
    isCancelAcastPlusLoading: mutation.isLoading,
    isCancelAcastPlusError: mutation.isError,
    isCancelAcastPlusSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useCancelAcastPlus;
